
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"27","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Page-1","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"5-cols","fill":"#A4A8C0","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M26 0a2.38 2.38 0 012.38 2.38V24A2.38 2.38 0 0126 26.38H2.38A2.38 2.38 0 010 24V2.38A2.38 2.38 0 012.38 0H26zm1.67 5.659H.75V24c0 .9.73 1.63 1.63 1.63H26A1.63 1.63 0 0027.67 24V5.659zM6.902 8.09c.214 0 .388.224.388.5v14.06c0 .276-.174.5-.388.5H4.218c-.214 0-.388-.224-.388-.5V8.59c0-.276.174-.5.388-.5h2.684zm4.303 0c.214 0 .387.224.387.5v14.06c0 .276-.173.5-.387.5H8.52c-.214 0-.387-.224-.387-.5V8.59c0-.276.173-.5.387-.5h2.685zm4.302 0c.214 0 .388.224.388.5v14.06c0 .276-.174.5-.388.5h-2.684c-.214 0-.388-.224-.388-.5V8.59c0-.276.174-.5.388-.5h2.684zm4.303 0c.214 0 .388.224.388.5v14.06c0 .276-.174.5-.388.5h-2.685c-.214 0-.387-.224-.387-.5V8.59c0-.276.173-.5.387-.5h2.685zm4.302 0c.214 0 .388.224.388.5v14.06c0 .276-.174.5-.388.5h-2.684c-.214 0-.388-.224-.388-.5V8.59c0-.276.174-.5.388-.5h2.684zM26 .75H2.38c-.9 0-1.63.73-1.63 1.63v2.529h26.92V2.38A1.63 1.63 0 0026 .75zM3.58 2.3a.74.74 0 01.732.632l.008.118a.75.75 0 01-.64.742l-.1.008a.76.76 0 01-.75-.75.75.75 0 01.648-.743L3.58 2.3zm2.88 0a.74.74 0 01.732.632l.008.118a.75.75 0 01-.64.742l-.1.008a.76.76 0 01-.75-.75.75.75 0 01.648-.743L6.46 2.3zm2.88 0a.74.74 0 01.732.632l.008.118a.75.75 0 01-.64.742l-.1.008a.76.76 0 01-.75-.75.75.75 0 01.648-.743L9.34 2.3z","id":"Shape"}})])])])
          )
        }
      }
    